<template>
  <v-container :class="$vuetify.breakpoint.smAndDown ? 'px-2 pt-2' : ''">
    <h1 class="text-center">Von der Punktevergabe ausgeschlossene User</h1>
    <p class="text-center mb-6">
      Diese User bekommen keine Loyalty-, Monthly- oder XP-Punkte mehr automatisch gutgeschrieben (z.B. für eigene Bot-Accounts).
    </p>

    <v-row>
      <v-col cols="12" md="8" offset-md="2">
        <v-form ref="form" v-model="formValid" @submit.prevent="addUser">
          <v-row dense>
            <v-col cols="12" sm="9">
              <v-text-field
                v-model="newUserName"
                label="Twitch-Username"
                :rules="[(v) => !!v || 'Username darf nicht leer sein']"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-btn
                color="primary"
                block
                @click="addUser"
                :loading="adding"
              >Hinzufügen</v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>

    <v-row class="mt-4">
      <v-col cols="12" md="8" offset-md="2">
        <!-- Desktop: Data Table -->
        <v-data-table
          v-if="!$vuetify.breakpoint.smAndDown"
          :headers="headers"
          :items="excludedUsers"
          :items-per-page="10"
          no-data-text="Aktuell sind keine User ausgeschlossen."
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn icon color="error" @click="removeUser(item)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>

        <!-- Mobile: Card List -->
        <template v-else>
          <v-card v-for="item in excludedUsers" :key="item.id" class="mb-2" outlined>
            <v-card-text class="d-flex align-center py-3">
              <v-avatar size="40" color="red lighten-4" class="mr-3 flex-shrink-0">
                <v-icon color="red darken-2">mdi-account-cancel-outline</v-icon>
              </v-avatar>
              <div class="flex-grow-1 text-truncate mr-2 font-weight-medium">
                {{ item.user_name }}
              </div>
              <v-btn icon color="error" @click="removeUser(item)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-card-text>
          </v-card>
          <v-alert v-if="excludedUsers.length === 0" type="info" class="mt-2">
            Aktuell sind keine User ausgeschlossen.
          </v-alert>
        </template>
      </v-col>
    </v-row>

    <v-snackbar v-model="saved" timeout="3000" color="green">
      Gespeichert!
      <template v-slot:actions>
        <v-btn color="pink" variant="text" @click="saved = false">Close</v-btn>
      </template>
    </v-snackbar>
    <v-snackbar v-model="error" timeout="3000" color="red">
      {{ errorMessage }}
      <template v-slot:actions>
        <v-btn color="pink" variant="text" @click="error = false">Close</v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import BackendService from '@/services/BackendService';

export default {
  name: 'PointsExclusionSettings',
  data() {
    return {
      excludedUsers: [],
      newUserName: '',
      formValid: false,
      adding: false,
      saved: false,
      error: false,
      errorMessage: '',
      headers: [
        { text: 'Username', value: 'user_name' },
        {
          text: '', value: 'actions', align: 'end', sortable: false,
        },
      ],
    };
  },
  mounted() {
    this.loadUsers();
  },
  methods: {
    loadUsers() {
      BackendService.loadExcludedUsers({ variant: 1 }).then((data) => {
        this.excludedUsers = data.data;
      });
    },
    addUser() {
      if (!this.$refs.form.validate() || !this.newUserName) return;
      this.adding = true;
      BackendService.saveExcludedUser({ variant: 1, name: this.newUserName }).then((data) => {
        this.excludedUsers = data.data;
        this.newUserName = '';
        this.saved = true;
      }).catch(() => {
        this.errorMessage = 'User konnte nicht gefunden oder hinzugefügt werden.';
        this.error = true;
      }).finally(() => {
        this.adding = false;
      });
    },
    removeUser(item) {
      BackendService.deleteExcludedUser({ variant: 1, id: item.id }).then((data) => {
        this.excludedUsers = data.data;
        this.saved = true;
      });
    },
  },
};
</script>
